import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {setContext} from 'apollo-link-context'
const httpLink = createHttpLink({
    uri: 'https://graphql.contentful.com/content/v1/spaces/yrbwhdouvd6q',
})


const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            Authorization: 'Bearer RMx2eNPTe_HNCGypSxXJDtPm3ZeJcT61M6TqPvcCRRY',
        }
    }
});

const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    defaultOptions: {
     query: {
         fetchPolicy: 'cache-and-network'
     }
    }
    ,
    cache,
})
